import { PolicyCheck } from '@/features/auth/authorization';

export const MapPolicies: Record<string, PolicyCheck> = {
  'map.view': ({ acl }) => acl.map.view,
  'settings.map.edit': ({ acl }) => acl.map.edit,
};
